/*
 * View-transitions guard — disables cross-document view transitions inside
 * Android WebViews and common in-app browsers (Instagram, Facebook, Line…),
 * where they have shown rendering bugs (matches Horizon's behaviour). Elsewhere
 * the CSS opt-in in base.css (@view-transition { navigation: auto }) stands.
 *
 * It appends an @view-transition { navigation: none } rule; being later in the
 * cascade than base.css, it wins. Runs once on load, before any subsequent
 * navigation triggers a transition.
 */
(() => {
  const ua = navigator.userAgent || '';
  const isAndroidWebView =
    /Android/.test(ua) && (/;\s*wv[);]/.test(ua) || /\bwv\b/.test(ua) || /FBAN|FBAV|Instagram|Line\/|GSA\//.test(ua));
  if (!isAndroidWebView) return;

  const style = document.createElement('style');
  style.textContent = '@view-transition { navigation: none; }';
  document.head.appendChild(style);
})();
